__turbopack_context__.v({
  "content": "tooltip-module__z8zniW__content",
});
